// Check if fulltext search has results

/**
 * Проверяет наличие результатов полнотекстового поиска
 * @returns {boolean} true если есть результаты, false если пусто
 */
export function hasFulltextResults() {
    const $container = $('#nav-full-text');
    if (!$container.length) return false;
    
    // Проверяем наличие элементов результатов
    const $results = $container.find('.search-result-item');
    if ($results.length > 0) return true;
    
    // Проверяем состояние загрузки
    const $spinner = $container.find('.fulltext-loading-spinner');
    if ($spinner.length && !$spinner.hasClass('d-none')) return false; // Идет загрузка
    
    // Проверяем empty state
    const $empty = $container.find('.empty-content');
    if ($empty.length && !$empty.hasClass('d-none')) return false; // Показывается empty state
    
    // Если нет ни результатов, ни empty state, ни спиннера - считается пустым
    return false;
}

